import type {
  IntegrationCreateRequestType,
  IntegrationCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useIntegrationCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: IntegrationCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `integration`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as IntegrationCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Integrations],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Integrations],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SellarIntegration],
      });
    },
  });
};
